import styled from "styled-components";
import { FaCheckCircle } from "react-icons/fa";
import { createStyledIcon } from "utils/iconUtils";

const CheckCircleIcon = createStyledIcon(FaCheckCircle);

export const SuccessModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SuccessTitle = styled.h2`
  color: ${({ theme }) => theme.colors.success};
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SuccessIcon = styled(CheckCircleIcon)`
  margin-right: 8px;
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.success};
`;

export const SuccessMessageText = styled.p`
  font-size: 16px;
  text-align: center;
  color: #000000;
  margin-bottom: 24px;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
